import ServiceBus from "servicestack/service-bus";
import basicController from "servicestack/basic.controller.properties";
import modals from "webmodals/modals";
import actionList from "webmodals/action-list";

export default class CartPricelistDropdownMenuController {
  constructor($cart, $scope) {
    const $ctrl = this;
    basicController($ctrl);
    $ctrl.bus = new ServiceBus();
    $ctrl.$scope = $scope;
    $ctrl.$cart = $cart;
    $ctrl.bus.send("QueryUsers.json?Id=" + $ctrl.$session.userAuthId).then(function(res) {
      if (res.data.results.length) {
        $ctrl.user = res.data.results[0];
        $ctrl.bus
        .send("QueryPriceLists.json?GroupBy=PriceListId&OrderBy=PriceListId")
        .then(function (res) {
          $ctrl.pricelists = res.data.results;
          if ($ctrl.user.meta && $ctrl.user.meta.CurrentPriceList) {
            $ctrl.pricelists.map(list => {
              if (list.priceListId == $ctrl.user.meta.CurrentPriceList) {
                list.selected = true;
              }
            })
          }
        });
      }
    });

  }

  setPriceList(pl) {
    const $ctrl = this;
    if ($ctrl.user) {
      if ($ctrl.$cart.id) {
        const activeCartActions = {
          "Active Cart": {
            icon: "refresh",
            body: "This will remove all items from your cart",
            handler: () => {
              $ctrl.bus.send("ApplyPriceList.json", {
                CartId: $ctrl.$cart.id,
                PriceListId: pl.priceListId,
                ClearCart: true
              }).then(function(res) {
                $ctrl.user.meta["CurrentPriceList"] = pl.priceListId == "Default" ? "" : pl.priceListId;
                $ctrl.bus.send("UpdateUser.json", $ctrl.user).then(res => {
                  window.location.reload();
                });
              });
            },
          },
          Cancel: {
            icon: "times",
            handler: function () {
            },
          },
        };
        return actionList({
          title: "You have an active cart",
          body: "How would you like to proceed?",
          actions: activeCartActions,
          size: "md",
        }).then((a) => a.handler());
      } else {
        $ctrl.user.meta["CurrentPriceList"] = pl.priceListId == "Default" ? "" : pl.priceListId;
        $ctrl.bus.send("UpdateUser.json", $ctrl.user).then(res => {
          window.location.reload();
        });
      }
    }
  }

}
